import React from "react";
import "./contactusblock.css"; // if you have styling

const ContactUsBlock = ({
  image,
  name,
  subtitle,
  description,
}) => {
  return (
    <div className="contact-us-ss-block-ui">
      {/* Image */}
      <div className="ssb-img">
        <img
              src={image}
              
          />
      </div>

      {/* Content */}
      <div className="ssb-cnt">
        {/* <div className="ssb-desc"> */}
          <p><i className="ri-map-pin-2-fill"></i>{description}</p>
        {/* </div> */}
      </div>
    </div>
  );
};

export default ContactUsBlock;
